import { SUPER_PROJECT_NAME } from 'src/constants';
import styles from './SuperNinjaTooltip.module.scss';

export const SuperNinjaTooltip = () => {
  return (
    <div className={styles.root}>
      <p className={styles.title}>
        <span className={styles.newLabel}>New</span>
        Try {SUPER_PROJECT_NAME}
      </p>

      <p className={styles.description}>
        Autonomous AI agent with it’s own computer. For research, coding, data
        analysis, creating websites, slides, spreadsheets and more.
      </p>
    </div>
  );
};
